import React from 'react';

import Box from '../../Box';
import BackgroundImage from '../../BackgroundImage';

const Decision = ({ src, ratio, height }) => (
  <Box px="5em">
    <BackgroundImage height={height} ratio={ratio} size="contain" src={src} />
  </Box>
)

export default Decision;
